// MessagingSection.jsx
import React, { useState } from "react";
import styles from "./MessagingSection.module.css";
import TabSelector from "../../components/TabSelector/TabSelector";
import SearchBar from "../../components/SearchBar/SearchBar";
import AllMessaging from "../AllMessaging/AllMessaging";

// ✅ Sample mock data (replace this later with real API/redux data)
const directData = [
  {
    name: "Darshan Sir",
    avatar: "https://i.pravatar.cc/150?img=11",
    unread: 1,
    title: "Darshan Sir",
    chat: [
      {
        from: "Darshan Sir",
        avatar: "https://i.pravatar.cc/150?img=11",
        text: "Have a great working week!!",
        time: "09:25 AM",
        side: "left",
        read: false,
      },
      {
        from: "You",
        avatar: "https://i.pravatar.cc/150?img=33",
        text: "You did your job well!!",
        time: "09:26 AM",
        side: "right",
        read: true,
      },
    ],
  },
  {
    name: "Varun Sir",
    avatar: "https://i.pravatar.cc/150?img=12",
    unread: 0,
    title: "Varun Sir",
    chat: [],
  },
];

const groupData = [
  {
    name: "Class 3A",
    avatar: "https://i.pravatar.cc/150?img=21",
    unread: 2,
    title: "Class 3A",
    members: "3 count",
    chat: [
      {
        from: "Darshan Sir",
        avatar: "https://i.pravatar.cc/150?img=11",
        text: "Have a great working week!!",
        time: "09:25 AM",
        side: "left",
        read: true,
      },
      {
        from: "You",
        avatar: "https://i.pravatar.cc/150?img=33",
        text: "You did your job well!!",
        time: "09:25 AM",
        side: "right",
        read: true,
      },
    ],
  },
  {
    name: "Class 4A",
    avatar: "https://i.pravatar.cc/150?img=22",
    unread: 0,
    title: "Class 4A",
    members: "2 count",
    chat: [],
  },
];

const MessagingSection = ({ type = "direct" }) => {
  const [activeTab, setActiveTab] = useState("All");
  const [searchValue, setSearchValue] = useState("");

  const tabOptions = [{ label: "All" }, { label: "Unread" }];

  return (
    <div className={styles.messagingWrapper}>
      <div className={styles.messagingContainer}>
        {/* Header */}
        <div className={styles.headerRow}>
          <TabSelector
            options={tabOptions}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className={styles.searchBar}>
            <SearchBar
              placeholder="Search by name"
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <span className={styles.showAllContacts}>
            {type === "group" ? "Create Group" : "Show all contacts"}
          </span>
        </div>

        {/* Chat area */}
        <div className={styles.messagingContent}>
          <AllMessaging
            type={type}
            data={type === "group" ? groupData : directData}
            searchQuery={searchValue}
            filterUnread={activeTab === "Unread"}
          />
        </div>
      </div>
    </div>
  );
};

export default MessagingSection;
